import React from 'react';
import Link, { type LinkProps } from '@discover-ui/link';
import { cn } from '@discover-lib/utils';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';

type PrivacyAndTermsLinksProps = {
  className?: LinkProps['className'];
  underline?: boolean;
};

const PrivacyAndTermsLinks = ({ className, underline = false }: PrivacyAndTermsLinksProps) => {
  const linkClassName = cn(
    'inline p-0 font-[inherit] leading-[inherit]',
    className,
    underline && 'underline hover:no-underline'
  );

  return (
    <>
      <TrackProvider link_name="privacy policy">
        <Link href="/privacy-policy" kind="link" className={linkClassName}>
          Privacy
        </Link>
      </TrackProvider>
      <span className={cn('text-gray', className)}>, </span>
      <TrackProvider link_name="cookie policy">
        <Link href="/cookie-policy" kind="link" className={linkClassName}>
          Cookies
        </Link>
      </TrackProvider>{' '}
      <span className={cn('text-gray', className)}>and</span>{' '}
      <TrackProvider link_name="terms and conditions">
        <Link href="/terms-and-conditions" kind="link" className={linkClassName}>
          Terms
        </Link>
      </TrackProvider>
    </>
  );
};

export default PrivacyAndTermsLinks;
